import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'm-folder-closed-icon',
  templateUrl: 'folder-closed-icon.component.html'
})
export class FolderClosedIconComponent {
  constructor() {}
}
